import Mediator from '../core/mediator';
/**
 * Decorates the class with mediatable
 * Gives access to create and dispatch custom events from a queue
 * Used to communicate cross platform - to non-Durango Framework JS
 * @param {Object} MediatableOptions
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mediatable(namespace, eventNames) {
    return (target) => {
        const { prototype: proto } = target;
        // Register each event specified
        eventNames.forEach((eventName) => Mediator.register(namespace, eventName));
        // Add a mediate() function to the object's prototype to simplify firing of mediated events
        proto.mediate = function mediate(eventName, eventData = {}) {
            Mediator.fire(namespace, eventName, eventData);
        };
        return target;
    };
}
